import { isAndroidtv, isTvos } from '@rnv/renative';

export default isTvos() || isAndroidtv();
